export const ANNOTATION_TYPES = [
  'text',
  'link',
  'arrow',
  'line',
  'position-image',
];

export function isAnnotationType(type) {
  return ANNOTATION_TYPES.includes(type);
}

export function sanitizeAnnotations(annotations) {
  return Array.isArray(annotations) ? annotations.filter(Boolean) : [];
}

export function sendAnnotationToBack(marker, image) {
  if (image && image.layer === marker.layer) {
    marker.insertAbove(image);
  } else {
    marker.sendToBack();
  }
}

/**
 * Keeps annotations above the diagram image and beneath measurement bubbles.
 * Skips malformed entries so initializeMarkers does not abort on refresh.
 */
export function reorderAnnotationLayers(allItems, callbacks) {
  const { sendToBack, bringToFront, onSendError, onBringError } = callbacks;

  allItems.forEach((item) => {
    if (!item || !item.marker || !isAnnotationType(item.type)) {
      return;
    }
    try {
      sendToBack(item.marker);
    } catch (error) {
      if (onSendError) {
        onSendError(error);
      }
    }
  });

  allItems.forEach((item) => {
    if (!item || !item.marker || isAnnotationType(item.type)) {
      return;
    }
    try {
      bringToFront(item.marker);
    } catch (error) {
      if (onBringError) {
        onBringError(error);
      }
    }
  });
}
